import React from "react";
import DashboardCard from "features/dashboard/components/DashboardCard";
import { useTranslation } from "react-i18next";
import AppWidgetCard from "components/ui/AppWidgetCard";
const Stats = ({ cardEarning, onlineEarning }) => {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-1 md:gap-6">
      <div className="col-span-2 md:col-span-1 text-center">
        <AppWidgetCard title={t("Cash Orders Earning")} amount={cardEarning} isPrice={true}></AppWidgetCard>
      </div>
      <div className="col-span-2 md:col-span-1 text-center">
        <AppWidgetCard title={t("Online Orders Earning")} amount={onlineEarning} isPrice={true}></AppWidgetCard>
      </div>
    </div>
  );
};

export default Stats;
